import { FC } from "react";
import Image from "next/legacy/image";
import { P1 } from "../atoms/Paragraph";
import { HeadingSize, H2 } from "../atoms/Heading";
import styled from "styled-components";
import { color as themeColor, colour } from "@styles";
import { Button, buttonVariant } from "../atoms/Button";
import { Card } from "../templates/Card";
import GiraffeFacingLeftSvg from "../../public/static/img/rebrand/svgs/GiraffeFacingLeft.svg";

const theme = {
  color: colour.white,
  backgroundColor: themeColor.S3100,
};

interface Props {
  title: string;
  body: string[];
  address?: string;
  link: string;
}

export const FindUsSection: FC<React.PropsWithChildren<Props>> = ({
  title,
  body,
  address,
  link,
}) => {
  return (
    <Section>
      <MapBackground />
      <Container>
        <Card
          positionedElement={
            <Yugi>
              <Image src={GiraffeFacingLeftSvg} alt="Yugi, YuLife’s giraffe mascot" />
            </Yugi>
          }
          cardColor={theme.backgroundColor}
        >
          <Content>
            <Title>
              <H2 size={HeadingSize.H1} color={theme.color}>
                {title}
              </H2>
            </Title>
            {!body.length
              ? null
              : body.map((text) => (
                  <Paragraph key={text} color={theme.color}>
                    {text}
                  </Paragraph>
                ))}
            {address && <Address color={theme.color}>{address}</Address>}
            <Button url="https://citymapper.com/go/po2qi9y2y4" variant={buttonVariant.mini}>
              {link}
            </Button>
          </Content>
        </Card>
      </Container>
    </Section>
  );
};

const Section = styled.section`
  position: relative;
  padding-bottom: 0;
  max-width: 100%;
  overflow: hidden;
`;

const MapBackground = styled.div`
  display: none;
  background-color: #eae1ff;
  background: url("/static/img/rebrand/MapImage.jpg");
  background-size: cover;
  background-position: center 80%;
  width: 100%;
  height: 71vw;
  max-height: 64.25rem;
  min-height: 50rem;
  z-index: 0;

  @media only screen and (min-width: 50rem) {
    display: block;
  }
`;

const Container = styled.div`
  width: 100%;
  padding-top: 2rem;
  background: linear-gradient(transparent 50%, #fff 50%);
  position: absolute;
  bottom: -5rem;

  @media only screen and (max-width: 50rem) {
    position: static;
  }

  @media only screen and (max-width: 45rem) {
    padding: 0;
  }
`;

const Content = styled.div`
  @media only screen and (min-width: 50rem) {
    padding-right: 10rem;
  }
`;

const Title = styled.div`
  margin-bottom: 1.5rem;

  @media only screen and (min-width: 30rem) {
    margin-bottom: 1rem;
  }
`;

const Paragraph = styled(P1)<{ color: string }>`
  color: ${(p) => p.color};
  margin-bottom: 2rem;
  padding: 0;
`;

const Address = styled(P1)<{ color: string }>`
  display: inline;
  color: ${(p) => p.color};
  margin-right: 2rem;
  margin-bottom: 2rem;
  padding: 0;
  font-weight: bold;
`;

const Yugi = styled.div`
  display: none;
  position: absolute;
  right: -2.75rem;
  bottom: -0.4rem;
  transform-origin: bottom right;
  transform: scale(1.5);

  @media only screen and (min-width: 50rem) {
    display: block;
  }
`;
